import { Component } from '@angular/core';

@Component({
  selector: 'app-calendar-skeleton-loader',
  templateUrl: './calendar-skeleton-loader.component.html',
  styleUrl: './calendar-skeleton-loader.component.scss'
})
export class CalendarSkeletonLoaderComponent {
  weekDays: string[] = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];


  get skeletonMonths() {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();
    const months = [];

    for (let month = 0; month <= currentMonth; month++) {
      months.push({
        key: `${currentYear}-${String(month + 1).padStart(2, '0')}`,
        days: this.generateSkeletonDays(month, currentYear)
      });
    }

    return months.reverse();
  }

  private generateSkeletonDays(month: number, year: number): any[] {
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const firstDayOfMonth = new Date(year, month, 1).getDay();

    const days = [];


    for (let i = 0; i < firstDayOfMonth; i++) {
      days.push({ isEmpty: true });
    }


    for (let i = 1; i <= daysInMonth; i++) {
      days.push({
        isEmpty: false,
        hasEvents: Math.random() > 0.7
      });
    }

    return days;
  }
}
